import React, { useEffect, useState } from "react";
import { Button, Layout } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowsUpDownLeftRight,
	faGifts,
	faRefresh,
} from "@fortawesome/pro-regular-svg-icons";
import { lineSpinner } from "ldrs";
import Draggable from "react-draggable";

import { bgColor, name } from "../../providers/companyInfo";
import useNetworkStatusChange from "../../providers/useNetworkStatusChange";
import ClearCache from "../../providers/ClearCache";
import Header from "./Header";
import Footer from "./Footer";

lineSpinner.register();

export default function Private(props) {
	const { children, title, subtitle, pageHeaderIcon, pageHeaderClass, pageId } =
		props;

	const [notifNoticePos, setNotifNoticePos] = useState({ x: 0, y: 0 });
	const [isDragNotifNotice, setIsDragNotifNotice] = useState(false);

	useNetworkStatusChange();

	useEffect(() => {
		if (title) {
			document.title = title + " | " + name;
		}
		return () => {};
	}, [title]);

	return (
		<ClearCache>
			{({ isLatestVersion, emptyCacheStorage }) => (
				<>
					{!isLatestVersion && (
						<Draggable
							axis="x"
							handle=".notification-notice"
							cancel=".action"
							position={notifNoticePos}
							grid={[10, 10]}
							scale={1}
							onStart={(e, data) => {
								// console.log("onStart e, data:", e, data);
								setNotifNoticePos({
									x: data.x,
									y: data.y,
								});
								setIsDragNotifNotice(true);
							}}
							onDrag={(e, data) => {
								// console.log("onDrag e, data:", e, data);
								setNotifNoticePos({
									x: data.x,
									y: data.y,
								});
							}}
							onStop={(e, data) => {
								// console.log("onStop e, data:", e, data);
								setNotifNoticePos({
									x: data.x,
									y: data.y,
								});
								setIsDragNotifNotice(false);
							}}
						>
							<div
								className={`notification-notice ${
									isDragNotifNotice ? "dragging" : ""
								}`}
							>
								<div className="notification-notice-content">
									<div className="notification-notice-drag">
										<FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
									</div>

									<div className="notification-notice-icon">
										<FontAwesomeIcon icon={faGifts} />
									</div>
									<div className="notification-notice-message">
										<div className="title">Updates Now Available</div>
										<div className="description">
											A new version of this Web App is ready
										</div>
										<div className="action">
											<Button
												onClick={(e) => {
													e.preventDefault();
													emptyCacheStorage();
												}}
												icon={<FontAwesomeIcon icon={faRefresh} />}
											>
												Refresh
											</Button>
										</div>
									</div>
								</div>
							</div>
						</Draggable>
					)}

					<div className="globalLoading hide">
						<l-line-spinner size="50" stroke="5" speed="1" color={bgColor} />
					</div>

					<Layout className="private-layout" id={pageId ?? ""}>
						<Header
							pageHeaderClass={pageHeaderClass}
							pageHeaderIcon={pageHeaderIcon}
							title={title}
							subtitle={subtitle}
							pageId={pageId}
						/>

						<Layout.Content>{children}</Layout.Content>

						<Footer />
					</Layout>
				</>
			)}
		</ClearCache>
	);
}
